import { SettingItemOptions } from './typings';

export const UPDATE_FREQUENCIES: SettingItemOptions = [
  { displayName: 'Show new people each day', value: 'daily' },
  { displayName: 'Show new people each week', value: 'weekly' },
  { displayName: 'Show new people each month', value: 'monthly' },
];

export const DISPLAY_YEAR_OPTIONS: SettingItemOptions = [
  { displayName: 'Display the number of years since the date', value: true },
  { displayName: 'Do not display the number of years since the date', value: false },
];

export const DISPLAY_FIRST_YEAR_OPTIONS: SettingItemOptions = [
  { displayName: 'Display people every year', value: true },
  { displayName: 'Skip displaying people on the first year', value: false },
];

export const DISPLAY_RECURRENCE_OPTIONS: SettingItemOptions = [
  { displayName: 'Display people each year', value: true },
  { displayName: 'Only display people on the year matching the date', value: false },
];
